<template>
  <div class="tlj">
    <el-row>
      <el-col :span="24">
        <el-alert
            title="温馨提示"
            type="success"
            close-text="知道了"
            show-icon>
          <p style="color: red">注意了！每个月滴滴佣金少于1元，不支持系统结算，支付宝转账接口只支持1元以上转账。</p>
        </el-alert>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table
            :data="items"
            :width="180"
            border>
          <el-table-column
              label="月份"
              prop="billDate"
              width="180">
          </el-table-column>
          <el-table-column
              label="结算金额"
              prop="withdrawCountYuan">
          </el-table-column>
          <el-table-column
              label="支付宝账号"
              prop="alipay">
          </el-table-column>
          <el-table-column
              label="支付宝姓名"
              prop="alipayName">
          </el-table-column>
          <el-table-column
              label="结算状态"
              prop="withdrawStatusDesc">
          </el-table-column>
          <el-table-column
              label="结算描述"
              prop="remark">
          </el-table-column>
          <el-table-column
              label="打款日期"
              prop="withdrawDate">
          </el-table-column>
<!--          <el-table-column fixed="right" label="操作" width="130">
            <template slot-scope="scope">
              <div class="operation">
                <div class="opt-item">
                  <el-button size="mini" type="primary">结算明细
                  </el-button>
                </div>
              </div>
            </template>
          </el-table-column>-->

        </el-table>

        <div class="pagination">
          <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-size="pageSize"
              layout="total,prev, pager, next"
              :total="totalCount">
          </el-pagination>
        </div>
      </el-col>
    </el-row>

  </div>
</template>
<script>
import {accountWithdrawApi} from "../../common/accountWithdrawApi.js"
import {taokeAppKeyApi} from "../../common/taokeAppKeyApi";

export default {
  data() {
    return {
      page: 1,
      pageSize: 10,
      items: [],
      totalCount: 0,
      appKeys: [],
      item: {
        taolijinType: "all",
        appKeyId: "all",
        pid: "all",
      },
      pids: []
    }

  },
  watch: {
    'item.appKeyId': {
      handler: function () {
        for (var i = 0; i < this.appKeys.length; i++) {
          if (this.appKeys[i].id == this.item.appKeyId) {
            this.pids = this.appKeys[i].pids;
            break
          }
        }
        if (this.item.appKeyId == "all") {
          this.item.pid = "all"
          this.pids = []
          for (let i = 0; i < this.appKeys.length; i++) {
            const appKey = this.appKeys[i];
            this.pids = this.pids.concat(appKey.pids)
          }
        }
      }
    },
  },
  computed: {

  },
  created() {
    var that = this;
    var data = {}
    data.page = that.page;
    data.pageSize = that.pageSize
    accountWithdrawApi.getItems.call(that, data, function (res) {
      if (res.result.data) {
        that.items = res.result.data
      }
      if (res.result.totalCount) {
        that.totalCount = res.result.totalCount
      }
    })
  },
  methods: {
    onCopy() {
      this.successMsg("复制成功");
    },
    onError() {
      this.failMsg("复制失败")
    },

    changePid() {
      this.$forceUpdate()
    },
    changeAppKeyId() {
      this.$forceUpdate()
    },
    loadAppKeys() {
      var that = this
      taokeAppKeyApi.getTaokeAppKey.call(that, {
        page: this.page,
        pageSize: this.pageSize
      }, function (res) {
        if (res.result.data) {
          that.appKeys = res.result.data
          for (let i = 0; i < that.appKeys.length; i++) {
            const appKey = that.appKeys[i];
            that.pids = that.pids.concat(appKey.pids)
          }
        }
      })
    },
    handleCurrentChange() {
      var that = this
      var data = {};
      data.page = that.page;
      data.pageSize = that.pageSize
      accountWithdrawApi.getItems.call(that, data, function (res) {
        if (res.result.data) {
          that.items = res.result.data
        }
        if (res.result.totalCount) {
          that.totalCount = res.result.totalCount
        }
      })
    },
    detailUrl(item) {
      return "https://item.taobao.com/item.htm?id=" + item.itemId;
    },
    onSubmit() {
      var that = this
      that.page = 1
      var data = this.adapterParam();
      data.page = that.page;
      data.pageSize = that.pageSize

      taobaoApi.getTaoLijins.call(this, data, function (res) {
        if (res.result.data) {
          that.items = res.result.data
        }
        if (res.result.totalCount) {
          that.totalCount = res.result.totalCount
        }
      });
    },
    adapterParam() {
      var that = this;
      var data = {}
      if ('all' != that.item.taolijinType) {
        data.taolijinType = that.item.taolijinType;
      }

      if ('all' != that.item.appKeyId) {
        data.appKeyId = that.item.appKeyId
      }

      if ('all' != that.item.pid) {
        data.pid = that.item.pid;
      }

      if (that.item.itemId) {
        data.itemId = that.item.itemId
      }

      if (that.item.taoToken) {
        data.taoToken = that.item.taoToken
      }
      return data;
    },
    endTimeMode(mode) {
      if (mode == 1) {
        return "相对时间"
      } else {
        return "绝对时间"
      }
    }
  }

}

</script>
<style lang="scss">
.tlj {
  .el-table__row {
    td {
      max-height: 150px;
    }
  }

  .el-table .cell {
    max-height: 100px;
  }

  .cell-item-img {
    height: 50px;
    line-height: 50px;
    text-align: left;
    display: flex;
  }

  .media-image {
    width: 50px;
    height: 50px;
  }

  .reflection {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 2;
    left: 0;
    top: 0;
    transition: all 0.1s ease;
    opacity: 0;
    mix-blend-mode: soft-light;
  }

  .el-table .cell {
    word-break: keep-all;
    text-overflow: unset;
  }

  .operation .opt-item {
    margin: 5px;
  }

  .operation button {
  }
}

</style>